import React, { useMemo } from "react";
import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";
import { useChart } from "../../../components/chart";

const formatCurrency = (value) =>
  new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(value);

export default function BuchungenStatistics({ chartLabels, chartSeries }) {
  const hasData =
    Array.isArray(chartLabels) &&
    chartLabels.length > 0 &&
    Array.isArray(chartSeries) &&
    chartSeries.length > 0;

  const seriesWithAxis = useMemo(
    () =>
      chartSeries.map((series) => ({
        ...series,
        yAxisIndex: series.type === "line" ? 1 : 0,
      })),
    [chartSeries]
  );

  const strokeWidths = useMemo(
    () => chartSeries.map((series) => (series.type === "line" ? 3 : 0)),
    [chartSeries]
  );

  const chartOptions = useChart({
    chart: {
      stacked: true,
      type: "line",
    },
    xaxis: {
      categories: chartLabels,
    },
    stroke: {
      width: strokeWidths,
    },
    yaxis: [
      {
        title: { text: "Summe (€)" },
        labels: {
          formatter: (value) => formatCurrency(value),
        },
      },
      {
        opposite: true,
        title: { text: "Mitglieder" },
        labels: {
          formatter: (value) => Math.round(value),
        },
      },
    ],
    tooltip: {
      shared: true,
      y: {
        formatter: (value, { seriesIndex }) => {
          const series = chartSeries?.[seriesIndex];
          if (series?.type === "line") {
            return `${Math.round(value)} Mitglieder`;
          }
          return formatCurrency(value);
        },
      },
    },
    plotOptions: {
      bar: { columnWidth: "40%" },
    },
  });

  if (!hasData) {
    return (
      <div style={{ padding: "16px 0" }}>
        Noch keine Buchungen vorhanden.
      </div>
    );
  }

  return (
    <ReactApexChart
      type="line"
      series={seriesWithAxis}
      options={chartOptions}
      height={360}
    />
  );
}

BuchungenStatistics.propTypes = {
  chartLabels: PropTypes.array.isRequired,
  chartSeries: PropTypes.array.isRequired,
};
